
export const FacebookSquare = () => (
  <svg width='24' height='25' viewBox='0 0 24 25' fill='#666666' xmlns='http://www.w3.org/2000/svg'>
    <path d='M20.4844 0.53125H3.51562C1.57727 0.53125 0 2.10852 0 4.04688V21.0156C0 22.954 1.57727 24.5312 3.51562 24.5312H10.5938V16.0469H7.78125V11.8281H10.5938V8.96875C10.5938 6.6424 12.4861 4.75 14.8125 4.75H19.0781V8.96875H14.8125V11.8281H19.0781L18.375 16.0469H14.8125V24.5312H20.4844C22.4227 24.5312 24 22.954 24 21.0156V4.04688C24 2.10852 22.4227 0.53125 20.4844 0.53125Z' fill=''/>
  </svg>
);